/**
 * Master tag list for sandbox component library presets. Every preset must reference tags only
 * through `SANDBOX_PRESET_TAG` so the catalog and filter UI stay aligned.
 */
export const SANDBOX_PRESET_TAG = {
  a11y: 'a11y',
  accordion: 'accordion',
  animation: 'animation',
  async: 'async',
  basics: 'basics',
  button: 'button',
  chart: 'chart',
  counter: 'counter',
  css: 'css',
  dnd: 'dnd',
  email: 'email',
  form: 'form',
  input: 'input',
  kanban: 'kanban',
  keyboard: 'keyboard',
  layout: 'layout',
  list: 'list',
  loading: 'loading',
  overlay: 'overlay',
  password: 'password',
  progress: 'progress',
  resize: 'resize',
  skeleton: 'skeleton',
  sort: 'sort',
  svg: 'svg',
  table: 'table',
  tabs: 'tabs',
  tags: 'tags',
  toast: 'toast',
  toggle: 'toggle',
  validation: 'validation',
} as const

export type SandboxPresetTag = (typeof SANDBOX_PRESET_TAG)[keyof typeof SANDBOX_PRESET_TAG]

/** All canonical tags in stable order (for filter UI: intersect with presets in use). */
export const SANDBOX_PRESET_TAG_LIST: readonly SandboxPresetTag[] = Object.values(SANDBOX_PRESET_TAG)
